import { LoadingStatus, needsLoading } from '@app/core';
import { of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State, selectScopeCategories, LoadingScopeCategoriesAction, selectScopeConstraints, LoadingScopeConstraintsAction } from '@app/access-management/state';
import { take, filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var shouldLoad = function (data) { return needsLoading(data); };
var ɵ0 = shouldLoad;
var hasData = function (data) { return !needsLoading(data); };
var ɵ1 = hasData;
var RoleScopeFacadeService = /** @class */ (function () {
    function RoleScopeFacadeService(store) {
        this.store = store;
        this.categories$ = of();
        this.constrains$ = of();
    }
    RoleScopeFacadeService.prototype.initializeCategories = function () {
        var _this = this;
        var categoriesStore$ = this.store.pipe(select(selectScopeCategories));
        categoriesStore$.pipe(take(1), filter(function (scopeCategoriesState) {
            return !scopeCategoriesState || scopeCategoriesState.status === LoadingStatus.LOAD_FAILED;
        }))
            .subscribe(function () { return _this.store.dispatch(new LoadingScopeCategoriesAction()); });
        this.categories$ = categoriesStore$.pipe(filter(function (scopeCategoriesState) {
            return !!scopeCategoriesState && scopeCategoriesState.status === LoadingStatus.LOAD_COMPLETE;
        }), map(function (scopeCategoriesState) { return scopeCategoriesState.data; }));
    };
    RoleScopeFacadeService.prototype.initializeConstrains = function (categoryId) {
        var _this = this;
        var constrainsStore$ = this.store.pipe(select(selectScopeConstraints(categoryId)));
        constrainsStore$.pipe(take(1), filter(function (constrainState) {
            return !constrainState || constrainState.status === LoadingStatus.LOAD_FAILED;
        }))
            .subscribe(function () { return _this.store.dispatch(new LoadingScopeConstraintsAction(categoryId)); });
        this.constrains$ = constrainsStore$.pipe(filter(function (state) {
            return !!state && state.status === LoadingStatus.LOAD_COMPLETE;
        }), map(function (state) { return state.data; }));
    };
    RoleScopeFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function RoleScopeFacadeService_Factory() { return new RoleScopeFacadeService(i0.inject(i1.Store)); }, token: RoleScopeFacadeService, providedIn: "root" });
    return RoleScopeFacadeService;
}());
export { RoleScopeFacadeService };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-scole.facade.ts.pre-build-optimizer.js